
import { ActivityTypes } from '../domain/enums';
import { IConfigurationFieldSearch_Response, IConfigurationFieldValue } from '../domain/ConfigurationField';
import { ISeas_Response, ISeasInfo } from '../domain/Seas';
import { IWinds_Response, IWindInfo } from '../domain/Wind';
import { IWeather_Response, IWeatherInfo } from '../domain/Weather';
import { IEquipmentInspectionPointItem, IEquipmentTypeInfo, IEquipment_Response,
         IEquipmentInfo,  IEquipmentStatusInfo } from '../domain/Equipment';
import { IPerson_Response, IPersonInfo } from '../domain/Person';
import { IUser_Response, IUserInfo } from '../domain/User';
import { IBoat_Response, IBoatInfo } from '../domain/Boat';
import { IVehicle_Response, IVehicleInfo } from '../domain/Vehicle';
import { IEquipmentStatus_Response, IEquipmentType_Response, IEquipmentInspectionPoint_Response } from '../domain/Equipment';
import { IIncidentDispositions_Response, IIncidentDispositionInfo } from '../domain/IncidentDisposition';
import { IActivityLogRole_Response, IActivityLogRoleInfo } from '../domain/ActivityLogRole';
import { IDeliveryMethod_Response, IDeliveryMethodInfo } from '../domain/DeliveryMethod';
import { ISafetyCheckInfo, ISafetyCheck_Response }  from '../domain/SafetyCheck';
import { IViolationTypeInfo, IViolationTypes_Response } from '../domain/Violation';
import { DataAccessService } from './dataAccessService';
import { getRegBoatList, getRegPersonList } from './asyncDataService';


export const getActivityType = (activityTypeId: number) => {
    let activityTypes = Object.keys(ActivityTypes).filter((x:any) => !isNaN(Number(ActivityTypes[x])));
    if (activityTypes.length > 0) {
        return activityTypes[activityTypeId];
    }   
    return '';  
};

export const capitalize = (str: string= '') => {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};

const right = (str:string, chr:number) => {
    return str.substr(str.length-chr, str.length);
};

// const left = (str:string, chr:number) => {
//     return str.substr(0, chr);
// }

const formatDate = (lDate:string, isCurrentDay:boolean, isCurrentWeek:boolean, isCurrentYear:boolean ) => {
    let ldDate = new Date(lDate);
    let smonth = ldDate.toLocaleString('default', { month: 'short' });
    let sday = ldDate.toLocaleString('default', {weekday: 'short'});
    
    if (isCurrentDay)
        return '';
    else if (isCurrentWeek) 
        return sday + ' ' + smonth + ' ' + ldDate.getDate() + ' ' + ldDate.getFullYear();
    else if (isCurrentYear)
        return sday + ' ' + smonth + ' ' + ldDate.getDate() + ' ' + ldDate.getFullYear();
    else 
        return sday + ' ' + smonth + ' ' + ldDate.getDate() + ' ' + ldDate.getFullYear();
}

export const formatListDates = (startDate: string, endDate: string, format24: string, canBeOpen:boolean) => {
    let lresult = "";
    let currentDate = new Date();
    let lstartDate = new Date(startDate);

    let isCurrentDay = (currentDate.getFullYear() === lstartDate.getFullYear() 
                            && currentDate.getMonth() === lstartDate.getMonth()
                            && currentDate.getDate() === lstartDate.getDate());

    let isCurrentYear = (currentDate.getFullYear() === lstartDate.getFullYear());

    let isCurrentWeek =  (currentDate.getFullYear() === lstartDate.getFullYear() 
                            && currentDate.getMonth() === lstartDate.getMonth()
                            && currentDate.getDate() - lstartDate.getDate() < 7);

    if (canBeOpen) {
        if (endDate) {
            let lendDate =  new Date(endDate);
            if (lendDate.getFullYear() === lstartDate.getFullYear() 
                        && lendDate.getMonth() === lstartDate.getMonth() 
                        && lendDate.getDate() === lstartDate.getDate())
                lresult =  formatDate(startDate, isCurrentDay, isCurrentYear, isCurrentWeek) 
                        + ' ' 
                        + ((format24 === "1") ? getClockTime24(lstartDate) : getClockTime12(lstartDate))
                        + ' - '  
                        + ((format24 === "1") ? getClockTime24(lendDate) : getClockTime12(lendDate));
            else
                lresult =  formatDate(startDate, isCurrentDay, isCurrentYear, isCurrentWeek) 
                        + ' ' 
                        + ((format24 === "1") ? getClockTime24(lstartDate) : getClockTime12(lstartDate))
                        + ' - '  
                        + formatDate(endDate, isCurrentDay, isCurrentYear, isCurrentWeek)
                        + ' ' 
                        + ((format24 === "1") ? getClockTime24(lendDate) : getClockTime12(lendDate));
        }
        else {
            lresult = formatDate(startDate, isCurrentDay, isCurrentYear, isCurrentWeek) 
                        + ' ' 
                        + ((format24 === "1") ? getClockTime24(lstartDate) : getClockTime12(lstartDate))
                        + ' - OPEN';
        }
    }
    else {
        lresult =  formatDate(startDate, isCurrentDay, isCurrentYear, isCurrentWeek) 
                + ' ' 
                + ((format24 === "1") ? getClockTime24(lstartDate) : getClockTime12(lstartDate));
    }
    
    return lresult;
}

export const formatDateForItem = (lDate:string) : string => {
    let ldDate = new Date(lDate);
    let smonth = ldDate.toLocaleString('default', { month: 'short' });
    let indexOfPoint = smonth.indexOf('.'); //logic for Android format date
    if (indexOfPoint > -1) {
        smonth = capitalize(smonth.substr(0,indexOfPoint));
    }
    return smonth + ' ' + ldDate.getDate() + ' ' + ldDate.getFullYear()
            + ' ' + right('00' + ldDate.getHours(), 2) + ':' + right('00' + ldDate.getMinutes(), 2)

}

export const formatDateForPopupItem = (lDate:Date, format24:string) : string => {
    // let ldDate = new Date(lDate);
    let smonth = lDate.toLocaleString('default', { month: 'short' });
    return smonth + ' ' + lDate.getDate() + ' ' + lDate.getFullYear()
            + ' ' 
            + ((format24 === "1") ? getClockTime24(lDate) : getClockTime12(lDate))

}

// export const formatDateForSave = (lNiceDate:string) : string => {
//     let stringDayToReturn = '';
//     if (lNiceDate) {
//         let year = new Date(lNiceDate).getFullYear();
//         let month = new Date(lNiceDate).getMonth();
//         let day = new Date(lNiceDate).getUTCDate();
//         stringDayToReturn = year + '-' + right('00' + month, 2) + '-' + right('00' + day, 2);
//         console.log(stringDayToReturn);
//     }
//     return stringDayToReturn;
// }

export const formatDateTimeForSave = (lNiceDate:string) : string => {
    console.log("lNiceDate = " + lNiceDate);
    let stringToReturn = '';
    let isGMT = lNiceDate.indexOf("GMT") > -1;
    let splitDate = lNiceDate.split(/[- :]/);
    if (isGMT) {
        if (splitDate.length >= 8) {
            let year = splitDate[3];
            let month = getMonthByName(splitDate[1]);
            let day =  splitDate[2];
            let hours =  splitDate[4];
            let min = splitDate[5];
            stringToReturn = year + '-' + month + '-' + day 
                                  + 'T' +  hours + ':' + min;
        }
    }
    else {
        if (splitDate.length === 5) {
            let year = splitDate[2];
            let month = getMonthByName(splitDate[0]);
            let day =  splitDate[1];
            let hours =  splitDate[3];
            let min = splitDate[4];
            stringToReturn = year + '-' + month + '-' + day 
                                  + 'T' +  hours + ':' + min;
        }
    }
    return stringToReturn;
}

const getMonthByName = (monthName:string) => {
    switch (monthName) {
        case "Jan":
        case "ian.":
            return '01';
        case "Feb":
        case "feb.":
            return '02';
        case "Mar":
        case "mar.":
            return '03';
        case "Apr":
        case "apr.":
            return '04';
        case "May":
        case "may.":
            return '05';
        case "Jun":
        case "jun.":
            return '06';
        case "Jul":
        case "jul.":
            return '07';
        case "Aug":
        case "aug.":
            return '08';
        case "Sep":
        case "sep.":
            return '09';
        case "Oct":
        case "oct.":
            return '10';
        case "Nov":
        case "nov.":
            return '11';
        case "Dec":
        case "dec.":
            return '12';
        default:
            return '';
    }
}

const getClockTime12 = (_lDate:Date) => {
    let hour   = _lDate.getHours();
    let minute = _lDate.getMinutes();
    let ap = "AM";
    let lhour = hour.toString();
    let lminute = minute.toString();
    if (hour > 11) { ap = "PM";}
    if (hour > 12) { lhour = String(hour - 12);}
    if (hour === 0) { lhour = "12";}
    if (hour < 10) { lhour = "0" + hour.toString();}
    if (minute < 10) { lminute = "0" + minute.toString(); }

    let timeString = lhour + ':' + lminute + " " + ap;
    return timeString;
 }

 const getClockTime24 = (_lDate:Date) => {
    return right('00' + _lDate.getHours(), 2) + ':' + right('00' + _lDate.getMinutes(), 2)
 }


export const b64toBlob = (b64Data:string, contentType:string='', sliceSize:number=512) : Blob => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

export  const urltoFile = async(url:string, filename:string, mimeType:string) => { 
    const response =  await fetch(url);
    const buf = await response.arrayBuffer();
    return new File([buf], filename, {type:mimeType});
    
    // return (fetch(url)
    //     .then(function(res){return res.arrayBuffer();})
    //     .then(function(buf){return new File([buf], filename,{type:mimeType});})
    // );
}

//#region "Reference Tables"

const loadSeas = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("seas");
    new DataAccessService()
        .getSeas(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let seasListDB = (JSON.parse(expectedData.toString()) as ISeas_Response).Options;
                        let seas: ISeasInfo[] = [];
                        if (seasListDB.length !== 0) {
                            seasListDB.forEach((v, i) => seas.push(v));
                            seas.push({"SeasID": 0, "Description": "Not Defined"})
                            window.localStorage.setItem("seas", JSON.stringify(seas));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

const loadWinds = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("winds");
    new DataAccessService()
        .getWinds(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let windsListDB = (JSON.parse(expectedData.toString()) as IWinds_Response).Options;
                        let winds: IWindInfo[] = [];
                        if (windsListDB.length !== 0) {
                            windsListDB.forEach((v, i) => winds.push(v));
                            winds.push({"WindID": 0, "Description": "Not Defined"});
                            window.localStorage.setItem("winds", JSON.stringify(winds));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

const loadWeather = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("weather");
    new DataAccessService()
        .getWeather(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let weatherListDB = (JSON.parse(expectedData.toString()) as IWeather_Response).Options;
                        let weather: IWeatherInfo[] = [];
                        if (weatherListDB.length !== 0) {
                            weatherListDB.forEach((v, i) => weather.push(v));
                            weather.push({"WeatherID": 0, "Description": "Not Defined"})
                            window.localStorage.setItem("weather", JSON.stringify(weather));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

const loadEquipmentStatuses = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("equipmentStatuses");
    new DataAccessService()
        .getEquipmentStatuses(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let equipmentStatusListDB = (JSON.parse(expectedData.toString()) as IEquipmentStatus_Response).Options;
                        let equipmentStatuses: IEquipmentStatusInfo[] = [];
                        if (equipmentStatusListDB.length !== 0) {
                            equipmentStatusListDB.forEach((v, i) => equipmentStatuses.push(v));
                            window.localStorage.setItem("equipmentStatuses", JSON.stringify(equipmentStatuses));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

const loadIncidentDispositions = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("incidentDispositions");
    new DataAccessService()
        .getIncidentDispositions(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let incidentDispositionListDB = (JSON.parse(expectedData.toString()) as IIncidentDispositions_Response).Options;
                        let incidentDispositions: IIncidentDispositionInfo[] = [];
                        if (incidentDispositionListDB.length !== 0) {
                            incidentDispositionListDB.forEach((v, i) => incidentDispositions.push(v));
                            window.localStorage.setItem("incidentDispositions", JSON.stringify(incidentDispositions));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

const loadActivityLogRoles = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("activityLogRoles");
    new DataAccessService()
        .getActivityLogRoles(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let activityLogRolesListDB = 
                            (JSON.parse(expectedData.toString()) as IActivityLogRole_Response).Options;
                        let activityLogRoles: IActivityLogRoleInfo[] = [];
                        if (activityLogRolesListDB.length !== 0) {
                            activityLogRolesListDB.forEach((v, i) => activityLogRoles.push(v));
                            window.localStorage.setItem("activityLogRoles", 
                                JSON.stringify(activityLogRoles));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

const loadDeliveryMethods = (token:string|null)  : boolean => {
    let isOk = true;
    window.localStorage.removeItem("deliveryMethods");
    new DataAccessService()
        .getDeliveryMethods(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let deliveryMethodsListDB = 
                            (JSON.parse(expectedData.toString()) as IDeliveryMethod_Response).Options;
                        let deliveryMethods: IDeliveryMethodInfo[] = [];
                        if (deliveryMethodsListDB.length !== 0) {
                            deliveryMethodsListDB.forEach((v, i) => deliveryMethods.push(v));
                            window.localStorage.setItem("deliveryMethods", 
                                JSON.stringify(deliveryMethods));
                        }
                    }
                    else {
                        isOk = false;
                    }
                },
                function (response) {
                    isOk = false;
                }
    );
    return isOk;
}

//#endregion "Reference Tables"

//#region "Configuration Tabels For Client"
const loadEquipmentList = (token:string|null) => {
    window.localStorage.removeItem("equipments");
    new DataAccessService()
    .getEquipmentList(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let equipmentListDB = (JSON.parse(expectedData.toString()) as IEquipment_Response).Equipments;
                    let equipments:IEquipmentInfo[] = [];
                    if (equipmentListDB.length !== 0) {
                        equipmentListDB.forEach((v, i) => equipments.push(v));
                        window.localStorage.setItem("equipments", JSON.stringify(equipments));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

const loadEquipmentTypes = (token:string|null) => {
    window.localStorage.removeItem("equipmentTypes");
    new DataAccessService()
    .getEquipmentTypes(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let equipmentTypesDB = 
                        (JSON.parse(expectedData.toString()) as IEquipmentType_Response).Options;
                    let equipmentTypes:IEquipmentTypeInfo[] = [];
                    if (equipmentTypesDB.length !== 0) {
                        equipmentTypesDB.forEach((v, i) => equipmentTypes.push(v));
                        window.localStorage.setItem("equipmentTypes", JSON.stringify(equipmentTypes));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

const loadEquipmentInspectionPoints = (token:string|null) => {
    window.localStorage.removeItem("equipmentInspectionPoints");
    new DataAccessService()
    .getEquipmentInspectionPoints(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let equipmentInspectionPointsDB = 
                        (JSON.parse(expectedData.toString()) as IEquipmentInspectionPoint_Response).Items;
                    let equipmentInspectionPoints: IEquipmentInspectionPointItem[] = [];
                    if (equipmentInspectionPointsDB.length !== 0) {
                        equipmentInspectionPointsDB.forEach((v, i) => equipmentInspectionPoints.push(v));
                        window.localStorage.setItem("equipmentInspectionPoints", JSON.stringify(equipmentInspectionPoints));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

const loadSafetyChecks = (token:string|null) => {
    window.localStorage.removeItem("safetyChecks");
    new DataAccessService()
    .getSafetyChecks(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let safetyChecksDB = 
                        (JSON.parse(expectedData.toString()) as ISafetyCheck_Response).SafetyChecks;
                    let safetyChecks: ISafetyCheckInfo[] = [];
                    if (safetyChecksDB.length !== 0) {
                        safetyChecksDB.forEach((v, i) => safetyChecks.push(v));
                        window.localStorage.setItem("safetyChecks", JSON.stringify(safetyChecks));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

const loadViolationTypes = (token:string|null) => {
    window.localStorage.removeItem("violationTypes");
    new DataAccessService()
    .getViolationTypes(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let violationTypesDB = 
                        (JSON.parse(expectedData.toString()) as IViolationTypes_Response).Options;
                    let violationTypes: IViolationTypeInfo[] = [];
                    if (violationTypesDB.length !== 0) {
                        violationTypesDB.forEach((v, i) => violationTypes.push(v));
                        window.localStorage.setItem("violationTypes", JSON.stringify(violationTypes));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

//#endregion "Configuration Tabels For Client"

//#region "Configuration Field Values"
const loadActivityTypeList = (token:string|null) => {
    window.localStorage.removeItem("activityTypes");
    new DataAccessService()
        .getActivityTypeList(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let activityTypesListDB = (JSON.parse(expectedData.toString()) as IConfigurationFieldSearch_Response).Results;
                        let activityTypes: IConfigurationFieldValue[] = [];
                        if (activityTypesListDB.length !== 0) {
                            activityTypesListDB.forEach((v, i) => activityTypes.push(v));
                            window.localStorage.setItem("activityTypes", JSON.stringify(activityTypes));
                        }
                    }
                    else {}
                },
                function (response) {}
    );
}

const loadCategoryList = (token:string|null) => {
    window.localStorage.removeItem("categories");
    new DataAccessService()
        .getCategoryList(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let categoriesListDB = (JSON.parse(expectedData.toString()) as IConfigurationFieldSearch_Response).Results;
                        let categories: IConfigurationFieldValue[] = [];
                        if (categoriesListDB.length !== 0) {
                            categoriesListDB.forEach((v, i) => categories.push(v));
                            window.localStorage.setItem("categories", JSON.stringify(categories));
                        }
                    }
                    else {
                    // isOk = false;
                    }
                },
                function (response) {
                // isOk = false;
                }
    );
//  return isOk;
}

const loadLocationList = (token:string|null) => {
    window.localStorage.removeItem("locations");
    new DataAccessService()
        .getLocationList(String(token))
            .then(
                function (expectedData) {
                    if (expectedData) {
                        let locationsListDB = (JSON.parse(expectedData.toString()) as IConfigurationFieldSearch_Response).Results;
                        let locations: IConfigurationFieldValue[] = [];
                        if (locationsListDB.length !== 0) {
                            locationsListDB.forEach((v, i) => locations.push(v));
                            window.localStorage.setItem("locations", JSON.stringify(locations));
                        }
                    }
                    else {
                    // isOk = false;
                    }
                },
                function (response) {
                    //isOk = false;
                }
    );
// return isOk;
}
//#endregion "Configuration Field Values"

//#region "Related to Activity Log Entries"
const loadUserList = (token:string|null, username:string) => {
    window.localStorage.removeItem("users");
    new DataAccessService()
    .getUserList(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let userListDB = (JSON.parse(expectedData.toString()) as IUser_Response).Users;
                    let users: IUserInfo[] = [];
                    if (userListDB.length !== 0) {
                        //if (username === "alinac" || username === "bhurley")
                            // filtering because general admininstrator
                            let _defaultClientID = String(window.localStorage.getItem("defaultClient"));
                            userListDB.filter((x) => x.ClientID.toString() === _defaultClientID).forEach((v, i) => users.push(v));
                        //else
                            //userListDB.forEach((v, i) => users.push(v));
                        window.localStorage.setItem("users", JSON.stringify(users));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

const loadPersonList = (token:string|null, username:string) => {
    window.localStorage.removeItem("persons");
    new DataAccessService()
    .getPersonList(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let personListDB = (JSON.parse(expectedData.toString()) as IPerson_Response).Persons;
                    let persons: IPersonInfo[] = [];
                    if (personListDB.length !== 0) {
                        //if (username === "alinac" || username === "bhurley"){
                            // filtering because general admininstrator
                            //personListDB.filter((x) => x.ClientID === 1 || x.ClientID === 89 || x.ClientID === 35).forEach((v, i) => persons.push(v));
                            let _defaultClientID = String(window.localStorage.getItem("defaultClient"));
                            personListDB.filter((x) => x.ClientID.toString() === _defaultClientID).forEach((v, i) => persons.push(v));
                            //personListDB.filter((x) => x.ClientID === 1 || x.ClientID === 89 || x.ClientID === 35).forEach((v, i) => persons.push(v));
                        // }
                        // else
                        //     personListDB.forEach((v, i) => persons.push(v));
                        window.localStorage.setItem("persons", JSON.stringify(persons));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

const loadBoatList = (token:string|null, username:string) => {
    window.localStorage.removeItem("boats");
    new DataAccessService()
    .getBoatList(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let boatListDB = (JSON.parse(expectedData.toString()) as IBoat_Response).Boats;
                    let boats: IBoatInfo[] = [];
                    if (boatListDB.length !== 0) {
                        //if (username === "alinac" || username === "bhurley")
                            // filtering because general admininstrator
                          //  boatListDB.filter((x) => x.ClientID === 1 || x.ClientID === 89 || x.ClientID === 35).forEach((v, i) => boats.push(v));
                        //else
                            //boatListDB.forEach((v, i) => boats.push(v));
                        let _defaultClientID = String(window.localStorage.getItem("defaultClient"));
                        boatListDB.filter((x) => x.ClientID.toString() === _defaultClientID).forEach((v, i) => boats.push(v));
                        window.localStorage.setItem("boats", JSON.stringify(boats));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}

export const loadRegBoatList = async (token:string) => {
    let boats: IBoatInfo[] = [];
    let expectedData = await getRegBoatList(token);
    if (expectedData){
        let boatListDB = (JSON.parse(expectedData.toString()) as IBoat_Response).Boats;
        if (boatListDB.length !== 0) {
            boatListDB.forEach((v, i) => boats.push(v)); 
        }
    }
    return boats;
}

export const loadRegPersonList = async(token:string) => {
    let persons: IPersonInfo[] = [];
    let expectedData = await getRegPersonList(token);
    if (expectedData){
        let personListDB = (JSON.parse(expectedData.toString()) as IPerson_Response).Persons;
        if (personListDB.length !== 0) {
            personListDB.forEach((v, i) => persons.push(v)); 
        }
    }
    return persons;
}

const loadVehicleList = (token:string|null) => {
    window.localStorage.removeItem("vehicles");
    new DataAccessService()
    .getVehicleList(String(token))
        .then(
            function (expectedData) {
                if (expectedData) {
                    let vehicleListDB = (JSON.parse(expectedData.toString()) as IVehicle_Response).Vehicles;
                    let vehicles: IVehicleInfo[] = [];
                    if (vehicleListDB.length !== 0) {
                        vehicleListDB.forEach((v, i) => vehicles.push(v));
                        window.localStorage.setItem("vehicles", JSON.stringify(vehicles));
                    }
                }
                else {
                }
            },
            function (response) {
            }
        );
}
//#endregion "Related to Activity Log Entries"

export const loadLists = (_token:string | null, _username:string) : boolean => {
    try {
        loadSeas(_token);
        loadWinds(_token);
        loadWeather(_token);
        loadIncidentDispositions(_token);
        loadEquipmentStatuses(_token);
        loadActivityLogRoles(_token); 
        loadDeliveryMethods(_token);

        loadEquipmentList(_token);
        loadEquipmentTypes(_token);
        loadEquipmentInspectionPoints(_token);
        loadSafetyChecks(_token);
        loadViolationTypes(_token);

        loadActivityTypeList(_token);
        loadCategoryList(_token);
        loadLocationList(_token);

        loadUserList(_token, _username);
        loadPersonList(_token, _username);
        loadBoatList(_token, _username);
        loadVehicleList(_token);

        return true;
    }
    catch (ex) {
        return false;
    }
}

//Usage example:
// urltoFile('data:text/plain;base64,aGVsbG8gd29ybGQ=', 'hello.txt','text/plain')
// .then(function(file){ console.log(file);});